// ============================================
// Memory Edit - Summary Layer (ES6)
// 요약 레이어 UI (수정만 가능, 추가/삭제 불가)
// ============================================

import { escapeHtml } from '../../utils.js';
import { renderEmptyState } from '../accordion.js';

// ============================================
// Summary 레이어 렌더링
// ============================================

export function renderSummaryLayer(data) {
  if (!data) {
    return renderEmptyState('summary');
  }

  return `
    <div class="memory-layer-content">
      <div class="memory-summary-item">
        <div class="summary-text" style="white-space: pre-wrap; line-height: 1.6; font-size: 13px; color: var(--text-primary); max-height: 400px; overflow-y: auto;">
          ${escapeHtml(data)}
        </div>
        <div class="memory-item-actions" style="margin-top: 12px;">
          <button class="memory-edit-btn" data-action="editSummary">
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
              <path d="M11 4H4a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2v-7"></path>
              <path d="M18.5 2.5a2.121 2.121 0 0 1 3 3L12 15l-4 1 1-4 9.5-9.5z"></path>
            </svg>
            수정
          </button>
        </div>
      </div>
    </div>
  `;
}

// ============================================
// 편집 폼 필드
// ============================================

export function getSummaryEditFields(item) {
  return [
    {
      name: 'summary',
      label: '요약 내용',
      type: 'textarea',
      value: item || '',
      placeholder: '세션의 요약 내용을 입력하세요...',
      required: true
    }
  ];
}

// ============================================
// 유효성 검사
// ============================================

export function validateSummaryData(formData) {
  const errors = [];

  if (!formData.summary?.trim()) {
    errors.push('요약 내용을 입력해주세요');
  }

  return errors;
}

// ============================================
// 데이터 변환
// ============================================

export function transformSummaryFormData(formData) {
  return formData.summary?.trim() || '';
}
